import React from 'react';

import styles from './BudgetGroup.module.css';
import RDSHeading from '../../components/RDSHeading/RDSHeading';

import classNames from 'classnames';

type BudgetGroupProps = {
  headingText: string;
  className?: string;
} & React.ComponentProps<'div'>;

const BudgetGroup = (props: BudgetGroupProps) => {
  return (
    <div className={classNames(styles.BudgetGroup, props.className)}>
      <RDSHeading level={'2'} size="xsmall" className={styles.Heading}>
        {props.headingText}
      </RDSHeading>
      <div className={styles.Content}>{props.children}</div>
    </div>
  );
};

export default BudgetGroup;
